/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import router from '../../router/index'
// eslint-disable-next-line no-unused-vars
const url = 'http://c.boaov.org/boaoweb'
const ajaxurl = 'http://api.19road.com/v1/'

export default {
  ajaxurl
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js